import React, { useState, useEffect } from 'react';
import { Button, Table, Space, Modal, Form, Select, TimePicker, message, Input } from 'antd';
import { inventoryAutoList, inventoryAutoSave, inventoryAutoEnabled, inventoryAutoDisabled, inventoryAutoDelete, inventorySuppliers } from '../../api';
import '../../style.less';
import moment from 'moment';
import { getAddressList } from '../../../apis/address';
const { Option } = Select;
const layout = { labelCol: { span: 8, }, wrapperCol: { span: 12, }, };
const tailLayout = { wrapperCol: { offset: 8, span: 8, }, };
const formatTime = 'HH:mm';
const weeks = ['一', '二', '三', '四', '五', '六', '日'];
// const base = { id: '', company_id: '', category_id: '', category_name: '', start: '', end: '', };

export default function OrderAutoSetting() {
  // const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [baseAddressList, setBaseAddressList] = useState([]);
  const [currentAddress, setCurrentAddress] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [currentCycle, setCurrentCycle] = useState(2);
  const [currentType, setCurrentType] = useState(0);
  const [type, setType] = useState('');
  // const [supplierId, setSupplierId] = useState('');
  const [currentId, setCurrentId] = useState('');
  const [form] = Form.useForm();
  const columns = [
    {
      title: '订货类型',
      dataIndex: 'type',
      key: 'type',
      width: 120,
      align: 'center',
      render: (text) => {
        return +text === 1 ? '建议补货' : 'CPM销售单';
      }
    },
    {
      title: '自动提交时间',
      dataIndex: 'cycle',
      key: 'cycle',
      width: 200,
      align: 'center',
      render: (text, record) => {
        const { run_time, which_day } = record;
        return <>
          {
            +text === 1 ?
              <>
                <span style={{ marginRight: 20 }}>每天</span>
                <span>{run_time ? moment(run_time, formatTime).format(formatTime) : ''}</span>
              </> :
              <>
                <span style={{ marginRight: 20 }}>周</span>
                <span>星期{weeks[which_day - 1]}</span>
              </>
          }
        </>;
      }
    },
    {
      title: '供应商名称',
      dataIndex: 'supplier',
      key: 'supplier',
      width: 200,
      align: 'center',
      render: (text) => {
        return text?.name || '无';
      }
    },
    {
      title: '收货地址',
      dataIndex: 'address',
      key: 'address',
      width: 300,
      align: 'center',
      render: (text) => {
        return `${text?.province_name}${text?.city_name}${text?.area_name}${text?.address}` || '无';
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 100,
      render: (text) => {
        return +text === 0 ? '禁用' : '启用';
      }
    },
    {
      title: '操作',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      render: (text, record) => {
        return <Space>
          <Button size='small' type='primary' onClick={() => updateItem(record)}>编辑</Button>
          <Button size='small' type='primary' onClick={() => updateItemx(record)}>{+record?.status === 0 ? '启用' : '禁用'}</Button>
          <Button size='small' type='primary' onClick={() => deleteInventoryOrderTime(record)}>删除</Button>
        </Space>;
      }
    },
  ];
  useEffect(() => {
    getInventoryOrderTimeList();
    // getInventoryOrderTimeCategories();
    AddressList();
    getInventorySuppliers();
  }, []);

  const AddressList = async () => {
    const { data: { data, msg, code } } = await getAddressList();
    if (+code === 0) {
      const { list = [] } = data;
      setBaseAddressList(list);
    } else {
      message.error(msg);
    }
  };
  const getInventorySuppliers = async () => {
    const { data: { data, msg, code } } = await inventorySuppliers();
    if (+code === 0) {
      const { list = [] } = data;
      setSuppliers(list);
    } else {
      message.error(msg);
    }
  };
  const getInventoryOrderTimeList = async () => {
    const { data: { data, msg, code } } = await inventoryAutoList();
    if (+code === 0) {
      const { list = [] } = data;
      setDataSource(list);
    } else {
      message.error(msg);
    }
  };
  // const getInventoryOrderTimeCategories = async () => {
  //   const { data: { data, msg, code } } = await inventoryOrderTimeCategories();
  //   if (+code === 0) {
  //     const { list = [] } = data;
  //     const newList = list.map(item => ({ category_id: item.id, category_name: item.name }));
  //     setCategories(newList);
  //   } else {
  //     message.error(msg);
  //   }
  // };
  const addInventoryOrderTime = async (arg) => {
    const { data: { msg, code } } = await inventoryAutoSave(arg);
    if (+code === 0) {
      getInventoryOrderTimeList();
      closeModal();
      message.success(msg);
    } else {
      message.error(msg);
    }
  };
  const updateInventoryOrderTime = async (arg) => {
    const { data: { msg, code } } = await inventoryAutoSave({ ...arg, id: currentId });
    if (+code === 0) {
      getInventoryOrderTimeList();
      closeModal();
      message.success(msg);
    } else {
      message.error(msg);
    }
  };
  const onFinish = (values) => {
    const formateData = { ...values, run_time: moment(values.run_time).format(formatTime) };
    const updateFun = {
      // 'add': (...arg) => addInventoryOrderTime(...arg),
      // 'update': (...arg) => updateInventoryOrderTime(...arg)
      'add': addInventoryOrderTime,
      'update': updateInventoryOrderTime
    };
    // updateFun[type]({ ...formateData, supplier_id: supplierId || '' });
    updateFun[type]({ ...formateData });
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const addOrderTime = () => {
    setVisible(true);
    setType('add');
    // setSupplierId('');
    form.setFieldsValue({
      type,
      which_day: '',
      run_time: '',
      status: '',
      address_id: "",
      cycle: ''
    });
  };
  const closeModal = () => {
    setVisible(false);
    setType('');
    setCurrentId('');
  };
  const updateItem = (item) => {
    const { type, which_day, run_time, id, status, address, cycle, supplier } = item;
    setVisible(true);
    setCurrentId(id);
    setType('update');
    // setSupplierId(supplier?.id);
    const condition = baseAddressList.find(addressItem => String(addressItem.id) === String(address.id));
    if (!condition) {
      setCurrentAddress([address]);
    }
    setCurrentCycle(+type);
    setCurrentType(+type);
    form.setFieldsValue({
      type,
      which_day: +which_day + 1,
      run_time: run_time ? moment(run_time, formatTime) : '',
      status,
      address_id: address?.id,
      cycle,
      supplier_id: supplier?.id
    });
  };
  const updateItemx = async (item) => {
    const { status, id } = item;
    const { data: { msg, code } } = await (+status === 0 ? inventoryAutoEnabled : inventoryAutoDisabled)({ id });
    if (+code === 0) {
      message.success(msg);
      getInventoryOrderTimeList();
    } else {
      message.error(msg);
    }
  };
  const deleteInventoryOrderTime = async ({ id }) => {
    const { data: { msg, code } } = await inventoryAutoDelete({ id });
    if (+code === 0) {
      getInventoryOrderTimeList();
      message.success(msg);
    } else {
      message.error(msg);
    }
  };

  return (
    <div className="proposal-order-list">
      <div className="plan-order-content">
        <div className='proposal-order-set'>
          <div style={{ visibility: 'hidden' }}>订货自动提交设置：</div>
          <Button type='primary' onClick={addOrderTime}>增加订货类型</Button>
        </div>
        <Table columns={columns} dataSource={dataSource} rowKey='id' pagination={false} locale={{ emptyText: '抱歉！暂无订货自动提交设置信息' }} />
        <Modal open={visible} title='订货自动提交设置' destroyOnClose footer={false} onCancel={closeModal}>
          <Form form={form} onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off" {...layout}>
            <Form.Item label="订货类型" name="type" rules={[{ required: true, message: '请订货类型!', },]}>
              <Select value={currentType} onChange={setCurrentType}>{[{ value: 1, name: '建议补货' }, { value: 2, name: 'CPM销售单' }].map(item => <Option value={item.value} key={item.value}>{item.name}</Option>)}</Select>
            </Form.Item>
            <Form.Item label="时间周期" name="cycle" rules={[{ required: true, message: '请时间周期!', },]}>
              <Select value={currentCycle} onChange={setCurrentCycle}>{[{ value: 1, name: '天' }, { value: 2, name: '周' }].map(item => <Option value={item.value} key={item.value}>{item.name}</Option>)}</Select>
            </Form.Item>
            {+currentCycle === 1 ?
              <Form.Item label="自动提交时间" name='run_time' rules={[{ required: true, message: '自动提交时间', },]}><TimePicker format={formatTime} /></Form.Item>
              :
              <Form.Item label="自动提交时间" required>
                <Input.Group>
                  <Form.Item name='which_day' noStyle rules={[{ required: true, message: '请选择周时间', },]}>
                    <Select placeholder="请选择" style={{ width: '40%', }}>
                      {weeks.map((item, index) => <Option value={index + 1} key={index + 1}>星期{item}</Option>)}
                    </Select>
                  </Form.Item>
                  <Form.Item name='run_time' noStyle rules={[{ required: true, message: '请选择具体时间', },]}>
                    <TimePicker format={formatTime} style={{ width: '60%', }} />
                  </Form.Item>
                </Input.Group>
              </Form.Item>}
            <Form.Item label="收货地址" name="address_id" rules={[{ required: true, message: '请时间周期!', },]}>
              <Select>{[...currentAddress, ...baseAddressList].map(item => <Option value={item.id} key={item.id}> {`${item?.province_name}${item?.city_name}${item?.area_name}${item?.address}`}</Option>)}</Select>
            </Form.Item>
            {
              +currentType === 1 ? <Form.Item label="供应商名称" name="supplier_id" rules={[{ required: true, message: '请选择供应商名称!', },]}>
                <Select>{(suppliers || []).map(item => <Option value={item.company_id} key={item.company_id}> {`${item?.company?.name}`}</Option>)}</Select>
              </Form.Item> : null
            }
            <Form.Item {...tailLayout}><div className='proposal-order-set'><Button type="primary" htmlType="submit">确认</Button><Button htmlType="button" onClick={closeModal}>取消</Button></div></Form.Item>
          </Form>
        </Modal>
      </div>
    </div >
  );
}
